import { Component, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { CrudForm } from "src/app/components/shared/cruds/crud.form";
import { PlantasDTO } from "src/app/models/plantas.dto";

@Component({
  selector: "app-form-drawer-plantas",
  templateUrl: "./drawer-form.component.html",
})
export class PlantasDrawerForm
  extends CrudForm<PlantasDTO>
  implements OnInit
{
  drawerRef: any;
  data?: {
    mode: "create" | "update";
    value: PlantasDTO;
  };
  constructor(
    public fb: FormBuilder,
  ) {
    super(fb);
  }
  public ngOnInit(): void {
    this.buildForm();
    if (this.data) {
      this.defaults = this.data.value;
      if (this.data.mode === "update") {
        this.setUpdate(this.data.value);
      } else {
        this.setCreate();
      }
    }
  }

  // TODO add validators
    public fromInit(row: PlantasDTO) {
      this.form.controls["IdPlanta"].setValue(row?.IdPlanta);
      this.form.controls["Nombre"].patchValue(row?.Nombre);
    }

    protected buildForm() {
      this.form = this.fb.group({
        IdPlanta: [""],
        Nombre: [""],
      });
    }

  public saveOver() {
    this.drawerRef.close({
      valid: this.form.invalid,
      data: {
        mode: this.mode,
        value: this.form.value,
      },
    });
  }

}
